module.exports = __webpack_public_path__ + "img/austria-cerebrovascular-disease-male.316d3455.png";